var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ds-toggle-component-wrapper"},[_c('label',{staticClass:"ds-toggle-wrapper"},[_c('span',{class:[
        'ds-toggle-container',
        {
          'ds-toggle-container-inactive': !_vm.toggleValue,
          'ds-toggle-container-active': _vm.toggleValue
        }
      ]}),_c('span',{class:[
        'ds-toggle-circle',
        {
          'ds-toggle-circle-active': _vm.toggleValue,
          'ds-toggle-circle-inactive': !_vm.toggleValue
        }
      ]}),_c('span',{class:[
        'ds-toggle-text',
        {
          'ds-toggle-text-active': _vm.toggleValue,
          'ds-toggle-text-inactive': !_vm.toggleValue
        }
      ]},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toggleValue),expression:"toggleValue"}],staticClass:"ds-toggle-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.toggleValue)?_vm._i(_vm.toggleValue,null)>-1:(_vm.toggleValue)},on:{"change":function($event){var $$a=_vm.toggleValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.toggleValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.toggleValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.toggleValue=$$c}}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }